import { type ReactElement } from 'react';

import DraftArena from './components/DraftArena';
import DraftBetweenPacks from './components/DraftBetweenPacks';
import DraftReview from './components/DraftReview';
import DraftSetup from './components/DraftSetup';
import { useDraftActions } from './hooks/useDraftActions';

export default function DraftPage(): ReactElement {
  const { session } = useDraftActions();

  if (!session || session.status === 'setup') {
    return <DraftSetup />;
  }

  if (session.status === 'loading') {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-600 border-t-blue-500" />
        <p className="text-sm text-zinc-400">Opening boosters...</p>
      </div>
    );
  }

  if (session.status === 'between-packs') {
    return <DraftBetweenPacks />;
  }

  if (session.status === 'review' || session.status === 'building') {
    return <DraftReview />;
  }

  return <DraftArena />;
}
